import { api } from './index';

export const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    getApiUser: build.query({
      query: () => `/user`,
    }),
    loginApiUser: build.query({
      query: () => `/login`
    }),
    logoutApiUser: build.query({
      query: () => `/logout`
    })
  }),
});

export const {
  useLazyGetApiUserQuery,
  useLazyLoginApiUserQuery,
  useLazyLogoutApiUserQuery
} = userApi;
